import "./AboutUs.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import TheGoldenYearsStory from "./sections/TheGoldenYearsStory";
import ProfessionalCertifications from "./sections/ProfessionalCertifications";
import DevelopmentMilestones from "./sections/DevelopmentMilestones";
import FooterInformation from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <NavigationHeader />
      <TheGoldenYearsStory />
      <ProfessionalCertifications />
      <DevelopmentMilestones />
      <FooterInformation />
    </div>;
}